import React, { useContext } from 'react';
import { Context as RestaurantContext } from '../../context/restaurant';
import MainLayout from '../../layouts/mainLayout';
import Loader from '../../components/misc/loader';
import OrderDeliveryMenu from '../../features/menu/components/order/delivery/orderMenu';
import { useDeliveryPageInit } from '../../hooks/useDeliveryPageInit';
import { useDeliveryMenuInit } from '../../hooks/useDeliveryMenuInit';

const MenuDeliveryPage = () => {
  const { isLoadingDeliveryInit, isSelectedRestaurantInit, selectedRestaurant } =
    useDeliveryPageInit();

  useDeliveryMenuInit({
    isLoadingDeliveryInit,
    isSelectedRestaurantInit,
    selectedRestaurant,
  });

  const { state: restaurantState } = useContext(RestaurantContext);

  if (
    isLoadingDeliveryInit ||
    !isSelectedRestaurantInit ||
    restaurantState.loadingMenu ||
    !restaurantState.menuGot ||
    !selectedRestaurant
  ) {
    return <Loader />;
  }

  return (
    <MainLayout>
      <OrderDeliveryMenu
        deliveryRestaurant={selectedRestaurant}
        productCategories={restaurantState.productCategories}
      />
    </MainLayout>
  );
};

export default MenuDeliveryPage;
